import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle"
import { ICupom } from "../../../../../pedidos/interface/ICupom";
import { useSnackbar } from "../../../../../core/contexts/SnackbarContext";

interface ExcluirCupomModalProps {
    open: boolean;
    cancelar: () => void;
    excluir: (cupomUuid: string) => void;
    cupom?: ICupom;
}

export const ExcluirCupomModal = ({ open, cancelar, excluir, cupom }: ExcluirCupomModalProps) => {
    const snackbar = useSnackbar();
    const handleExcluirCupom = () => {
        if(!cupom || !cupom.uuid) {
            return snackbar("Cupom inválido", { severity: "error" });
        }

        excluir(cupom.uuid);
    }

    return (
        <Dialog
            open={open}
            onClose={cancelar}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Excluir cupom {cupom?.nome || cupom?.codigo}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Realmente deseja excluir este cupom?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancelar}>Não</Button>
                <Button onClick={handleExcluirCupom} autoFocus>
                    Sim
                </Button>
            </DialogActions>
        </Dialog>
    );
}

